import { NavLink, useLocation } from "react-router-dom";
import UseFetch from "../components/UseFetch";
import $ from 'jquery';
import { useEffect, useRef, useState } from "react";
import ModalSendSms from "./ModalSendSms";
import Swal from "sweetalert2";
import { decryptData, defaulUrl, fmt } from "../components/const";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const DbAgent = () => {
    const locationState = useLocation()?.state || {};
    const agent = locationState.agent;

    const user = decryptData("USER");
    const id = agent?.id || user.id;

    const AgentName = agent ? `${agent.prenom} ${agent.nom}` : `${user.firstname} ${user.lastname}`;

    const { data: clients, isloading } = UseFetch('compte-agent/' + id);
    const tableRef = useRef();
    const [loading, setIsLoading] = useState(false);
    const [totalCreditFact, setTotalCrdtFact] = useState(0);
    const [totalCreditInit, setTotalCrdtInit] = useState(0);
    const [totalAvance, setTotalAvance] = useState(0);

    useEffect(() => {
        if (clients) {
            setTotalCrdtFact(clients.reduce((prev, curr) => prev + curr.credit, 0));
            setTotalCrdtInit(clients.reduce((prev, curr) => prev + curr.dette_initiale, 0));
            setTotalAvance(clients.reduce((prev, curr) => prev + curr.solde_avance, 0));
        }
    }, [clients]);

    const bloquerClient = (id) => {
        Swal.fire({
            title: "Bloquer/Débloquer client",
            text: "Souhaitez-vous vraiment effectuer cette opération",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON"
        }).then(confirm => {
            if (confirm.isConfirmed) {
                let status = 0;
                setIsLoading(true);
                fetch(`${defaulUrl}client/blocage/${id}`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`,
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    }
                }).then(response => {
                    status = response.status;
                    return response.json();
                }).then(data => {
                    setIsLoading(false);
                    if (status === 200) {
                        Swal.fire({ title: "Succès", text: data?.message, icon: 'success' });
                    }
                });
            }
        });
    };

    const handlePrint = () => {
        if (!clients?.length) return;

        const doc = new jsPDF("l", "pt");
        const pageWidth = doc.internal.pageSize.getWidth();

        // Titre
        doc.setFontSize(12);
        doc.text(`Liste des Clients de l'agent ${AgentName || ""}`, 20, 20);

        // Totaux
        const totalCreditFact = clients.reduce((sum, c) => sum + c.credit, 0);
        const totalCreditInit = clients.reduce((sum, c) => sum + c.dette_initiale, 0);
        const totalAvance = clients.reduce((sum, c) => sum + c.solde_avance, 0);

        // AutoTable
        autoTable(doc, {
            startY: 40,
            head: [[
                "N°",
                "CLIENT",
                "TELEPHONE",
                "SOLDE AVANCE",
                "CREDIT FACTURE",
                "CREDIT INITIALE",
                "CREDIT TOTAL",
                "DETTE MAX"
            ]],
            body: clients.map((client, index) => [
                index + 1,
                client.client?.toUpperCase(),
                client.telephone,
                fmt(client.solde_avance),
                fmt(client.credit),
                fmt(client.dette_initiale),
                fmt((client.credit + client.dette_initiale)),
                fmt(client.dettemax)
            ]),
            foot: [[
                "Totaux",
                "",
                "",
                fmt(totalAvance),
                fmt(totalCreditFact),
                fmt(totalCreditInit),
                fmt(totalCreditFact + totalCreditInit),
                ""

            ]],
            theme: "striped",
            headStyles: { fillColor: [41, 128, 185], textColor: 255 },
            footStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
            styles: { fontSize: 9, cellPadding: 3 },
            showHead: "everyPage",
            didDrawPage: function (data) {
                const pageNumber = doc.internal.getNumberOfPages();
                doc.setFontSize(8);
                doc.text(`Page ${pageNumber}`, pageWidth - 40, doc.internal.pageSize.getHeight() - 10, { align: "right" });
            }
        });

        doc.save(`clients_${id}.pdf`);
    };

    return (
        <div className="">
            {(isloading || loading) && <div className="loader"></div>}
            <h5 className="text-secondary">LISTE DES CLIENTS</h5>

            {clients?.length ? (
                <>
                    <div className="row mb-2">
                        <button className="btn btn-info text-white me-3 w-auto" data-bs-toggle="modal" data-bs-target="#modal-envoi">
                            Ecrire un client
                        </button>
                        <button className="btn btn-primary ms-2 w-auto" onClick={handlePrint}>
                            <i className="bx bx-printer"></i> Imprimer
                        </button>
                    </div>

                    <div className="table-responsive">
                        <table ref={tableRef} className="table table-striped table-bordered table-hover nowrap">
                            <thead className="table-dark">
                                <tr className="align-middle">
                                    <th>N°</th>
                                    <th>CLIENT</th>
                                    <th>TELEPHONE</th>
                                    <th>SOLDE AVANCE</th>
                                    <th>CREDIT FACTURE</th>
                                    <th>CREDIT INITIALE</th>
                                    <th>CREDIT TOTAL</th>
                                    <th>DETTE MAX</th>
                                    <th className="text-end">ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {clients.map((client, ind) => (
                                    <tr key={ind} className="align-middle">
                                        <td>{ind + 1}</td>
                                        <td>{client.client?.toUpperCase()}</td>
                                        <td>{client.telephone?.toUpperCase()}</td>
                                        <td>{client.solde_avance?.toLocaleString()} GNF</td>
                                        <td>{client.credit?.toLocaleString()} GNF</td>
                                        <td>{client.dette_initiale?.toLocaleString()} GNF</td>
                                        <td>{(client.dette_initiale + client.credit)?.toLocaleString()} GNF</td>
                                        <td>{client.dettemax?.toLocaleString()} GNF</td>
                                        <td>
                                            <NavLink to='/client/compte' state={{ client }} className="btn btn-primary m-1"><i className="bx bx-show"></i></NavLink>
                                            {client.isbloqued ? (
                                                <button className="btn btn-success m-1" onClick={() => bloquerClient(client.id)}><i className="bx bx-check-circle"></i></button>
                                            ) : (
                                                <button className="btn btn-danger m-1" onClick={() => bloquerClient(client.id)}><i className="bx bx-x-circle"></i></button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="row m-y px-2 justify-content-center">
                            <div className="col-lg-2 p-1">
                                <div className="card h-100 p-2 text-center">
                                    <span className="fw-bold">Total impaye Fac.</span>
                                    {totalCreditFact.toLocaleString()} GNF
                                </div>
                            </div>
                            <div className="col-lg-2 p-1">
                                <div className="card h-100 p-2 text-center">
                                    <span className="fw-bold">Total Dette init</span>
                                    {totalCreditInit.toLocaleString()} GNF
                                </div>
                            </div>
                            <div className="col-lg-2 p-1">
                                <div className="card h-100 p-2 text-center">
                                    <span className="fw-bold">Total Credit</span>
                                    {(totalCreditInit + totalCreditFact).toLocaleString()} GNF
                                </div>
                            </div>
                            <div className="col-lg-2 p-1">
                                <div className="card h-100 p-2 text-center">
                                    <span className="fw-bold">Total Avance</span>
                                    {totalAvance.toLocaleString()} GNF
                                </div>
                            </div>
                        </div>

                        <ModalSendSms clients={clients} />
                    </div>
                </>
            ) : (
                <div className="text-center p-3 fs-5 text-danger">Aucun client trouvé!</div>
            )}
        </div>
    );
};

export default DbAgent;
